import React from 'react';
import { ButtonLink } from './ButtonLink';
import { images } from '../data/site';
export function Fleets() {
  return <section aria-labelledby="fleet-title" className="grid w-full bg-white lg:grid-cols-2" data-id="element-138" data-mp="3btz8dy3hcfn8">
      <div className="relative min-h-[320px] lg:min-h-[520px]" data-id="element-139" data-mp="3gn1triy3sisc">
        <img src={images.fleet} alt="Commercial fishing workboat with outboards running across open water under an overcast sky in Eastern North Carolina" loading="lazy" className="absolute inset-0 h-full w-full object-cover" data-id="element-140" data-mp="3kncb1rrcivmi" />
      </div>
      <div className="gutter flex flex-col justify-center py-14 md:py-20" data-id="element-141" data-mp="2wxzrbxye755y">
        <h2 id="fleet-title" className="display text-[clamp(2.5rem,4.5vw,5rem)] font-extrabold text-navy" data-id="element-142" data-mp="2wwooc0cru1fw">
          Commercial &amp; Government Fleets
        </h2>
        <p className="mt-5 max-w-[52ch] text-lg leading-relaxed text-ink-muted" data-id="element-143" data-mp="c6qxryrolgdl">
          Trusted by commercial captains and public-service fleets across Eastern North Carolina. Fleet maintenance, priority scheduling and
          certified repairs.
        </p>
        <div className="mt-8" data-id="element-144" data-mp="341fsky7s6vaj">
          <ButtonLink href="#contact" data-id="element-145" data-mp="342h6dag6lvvy">Talk Fleet Service</ButtonLink>
        </div>
      </div>
    </section>;
}